// extracted by mini-css-extract-plugin
module.exports = {"IconButton":"IconButton_IconButton__3-YJF","active":"IconButton_active__1LZ6R"};